<div class="wrapper">
	<div class="page-intro__text">
		<h1 class="page-title" [innerHtml]="engageTitleTab"></h1>
		<div class="preamble" *ngIf="'' != engageWpDataTab" [innerHtml]="engageWpDataTab"></div>
	</div>
</div>
<section id="schedule" class="component component--engage engage">
	<div class="wrapper">
		<h2 class="component__title" *ngIf="engageDotNetDataTab[0].tab_engage_block_header != ''" [innerHtml]="engageDotNetDataTab[0].tab_engage_block_header"></h2>
		<div class="engage__title engage__wrapper">
			<div class="engage__head engage__what">What</div>
			<div class="engage__head engage__kind">Kind</div>
			<div class="engage__head engage__submissions">Submissions open</div>
			<div class="engage__head engage__actions">&nbsp;</div>
		</div>
		<div *ngFor="let eDVal of engageDotNetDataTab;let i = index">
			<h2 class="component__title" *ngIf="eDVal.tab_engage_block_header != '' && 0 != i" [innerHtml]="eDVal.tab_engage_block_header"></h2>
			<div class="engage__accordion accordion">
				<div class="engage__accordion-repeater accordion__repeater" *ngFor="let eVal of eDVal.programmes">
					<div class="engage__body engage__what">
						<h2 class="accordion__controller" (click)="accordion( $event, 'accordion__opened' )">
							<span class="accordion__controller_title">{{ eVal.title }} <i class="icon-breadcrumb-bottom"></i></span>
							<span class="engage__mobile">
								<span class="engage__kind" [innerHtml]="eVal.kindName"></span>
								<span class="engage__submissions" [innerHtml]="eVal.submissionOpen"></span>
								<span class="engage__actions">
									<a class="btn btn-primary btn-circle" href="{{ eVal.applyLink }}" target="{{ eVal.isExternalLink == true ? '_blank' : '_self'}}" *ngIf="eVal.isApplyOpen == true && eVal.isExternalLink == true">
									{{ eVal.linkDisplayText }} <i class="icon-breadcrumb-right"></i>
									</a>
									<!-- <a class="btn btn-primary btn-circle" (click)="goToLoginPage( eVal.applyLink )" href="javascript:;" *ngIf="eVal.isExternalLink == false && eVal.isApplyOpen == true && loggedIn == false">
										{{ eVal.linkDisplayText }} <i class="icon-breadcrumb-right"></i>
									</a> -->
									<!-- <a class="btn btn-primary btn-circle" href="{{ eVal.applyLink }}" target="{{ eVal.isExternalLink == true ? '_blank' : '_self'}}" *ngIf="eVal.isExternalLink == false && eVal.isApplyOpen == true && loggedIn == true"> -->
									<a class="btn btn-primary btn-circle" href="{{ eVal.applyLink }}" target="{{ eVal.isExternalLink == true ? '_blank' : '_self'}}"*ngIf="eVal.isExternalLink == false && eVal.isApplyOpen == true">
										{{ eVal.linkDisplayText }} <i class="icon-breadcrumb-right"></i>
									</a>
									<span class="btn btn-circle" *ngIf="eVal.isApplyOpen != true">
										Closed
									</span>
								</span>
							</span>
						</h2>
						<div class="accordion__content">
							<div class="entry-content" [innerHtml]="eVal.description | safe:'preamble'"></div>
							<div class="read-more" *ngIf="eVal.slug !== '25-exhibit-at-world-water-week' && eVal.ReadMore == null && eVal.ReadMore == ''"><a href="engage/apply/{{eVal.slug}}">Read more<i class="icon-arrow-right"></i></a></div>
							<div class="read-more" *ngIf="eVal.slug == '25-exhibit-at-world-water-week'"><a href="https://newprogramme.worldwaterweek.org/exhibitor-resources">Read more<i class="icon-arrow-right"></i></a></div>
							<div class="read-more" *ngIf="eVal.ReadMore != null && eVal.ReadMore != ''"><a href="{{ eVal.ReadMore }}">Read more<i class="icon-arrow-right"></i></a></div>
						</div>
					</div>
					<div class="engage__body engage__kind" [innerHtml]="eVal.kindName"></div>
					<div class="engage__body engage__submissions" [innerHtml]="eVal.submissionOpen"></div>
					<div class="engage__body engage__actions">
						<a class="btn btn-primary btn-circle" href="{{ eVal.applyLink }}" target="{{ eVal.isExternalLink == true ? '_blank' : '_self'}}" *ngIf="eVal.isApplyOpen == true && eVal.isExternalLink == true">
							{{ eVal.linkDisplayText }} <i class="icon-breadcrumb-right"></i>
						</a>
						<!-- <a class="btn btn-primary btn-circle" (click)="goToLoginPage( eVal.applyLink )" href="javascript:;" *ngIf="eVal.isExternalLink == false && eVal.isApplyOpen == true && loggedIn == false">
							{{ eVal.linkDisplayText }} <i class="icon-breadcrumb-right"></i>
						</a> -->
						<!-- <a class="btn btn-primary btn-circle" href="{{ eVal.applyLink }}" target="{{ eVal.isExternalLink == true ? '_blank' : '_self'}}"*ngIf="eVal.isExternalLink == false && eVal.isApplyOpen == true && loggedIn == true"> -->
						<a class="btn btn-primary btn-circle" href="{{ eVal.applyLink }}" target="{{ eVal.isExternalLink == true ? '_blank' : '_self'}}"*ngIf="eVal.isExternalLink == false && eVal.isApplyOpen == true">
							{{ eVal.linkDisplayText }} <i class="icon-breadcrumb-right"></i>
						</a>
						<span class="btn btn-circle" *ngIf="eVal.isApplyOpen != true">
							Closed
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>